var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddProdCatalogue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 74,
    viewBox: "0 0 70 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46 12.7941V9C46 6.79086 44.2091 5 42 5H36M23.5 58H5C2.79086 58 1 56.2091 1 54V9C1 6.79086 2.79086 5 5 5H11",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 46.6842H69V69C69 71.2091 67.2091 73 65 73H19V46.6842Z",
    fill: "#6BE3A2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4219 34.8421V23H50.5798V34.8421L44.0008 30.8947L37.4219 34.8421Z",
    fill: "#6BE3A2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44 73H23C20.7909 73 19 71.2091 19 69V48V27C19 24.7909 20.7909 23 23 23H32.1579H65C67.2091 23 69 24.7909 69 27V34.8421V50.6316",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2891 66.421C59.2891 66.6972 59.5129 66.921 59.7891 66.921C60.0652 66.921 60.2891 66.6972 60.2891 66.421H59.2891ZM60.1426 56.857C59.9474 56.6617 59.6308 56.6617 59.4355 56.857L56.2535 60.0389C56.0583 60.2342 56.0583 60.5508 56.2535 60.746C56.4488 60.9413 56.7654 60.9413 56.9606 60.746L59.7891 57.9176L62.6175 60.746C62.8128 60.9413 63.1293 60.9413 63.3246 60.746C63.5199 60.5508 63.5199 60.2342 63.3246 60.0389L60.1426 56.857ZM60.2891 66.421V57.2105H59.2891V66.421H60.2891Z",
    fill: "#383434"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32 1H15C12.7909 1 11 2.79086 11 5C11 7.20914 12.7909 9 15 9H32C34.2091 9 36 7.20914 36 5C36 2.79086 34.2091 1 32 1Z",
    stroke: "#383434",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddProdCatalogue);
export default __webpack_public_path__ + "static/media/addProdCatalogue.6212e64c983e7dc9189223d780b2d1c1.svg";
export { ForwardRef as ReactComponent };